const session_expired = {
    title: 'Sitzung abgelaufen',
    subtitle: 'Deine Sitzung ist möglicherweise abgelaufen und deine Verbindung wurde unterbrochen. Klicke auf die Schaltfläche unten, um dich erneut an der Admin Konsole anzumelden.',
    button: 'Erneut anmelden',
};
export default Object.freeze(session_expired);
